import * as classes from './classes';
import * as userAccounts from './userAccounts';
import * as utility from './utility';
let $ = require( 'jquery' );

let sceneData;

export function addUI(scene)
{

	sceneData = scene;

	// Define minimap toggle button.
	scene.minimapToggle = scene.add.sprite(25, 25, 'sprites', 'openMinimap.png')
		.setScrollFactor(0)
		.setInteractive()
		.setOrigin(0);
	scene.uiGroup.add(scene.minimapToggle);
	scene.minimapWidth = 250;
	scene.minimapHeight = 250;
	scene.minimapX = scene.minimapToggle.x + scene.minimapToggle.width;
	scene.minimapY = scene.minimapToggle.y + scene.minimapToggle.height;

	scene.minimapToggle.on('pointerdown', function () {

		if (scene.minimapToggle.frame.name == 'closeMinimap.png')
		{
			// console.log('minimap closed');
			scene.minimapToggle.setTexture('sprites', 'openMinimap.png');
			scene.minimapCamera.setSize(1,1);
		} else
		{
			// console.log('minimap opened');
			scene.minimapToggle.setTexture('sprites', 'closeMinimap.png');
			scene.minimapCamera.setSize(scene.minimapWidth, scene.minimapHeight);
		}

		if (scene.messageBoxes[0])
		{
			scene.messageBoxes[0].moveMessageBox(scene);
		}

	});

	// Define in-game menu toggle button.
	scene.inGameMenuToggle = scene.add.sprite(window.innerWidth - 25, 25, 'sprites', 'menuIcon.png')
		.setScrollFactor(0)
		.setInteractive()
		.setOrigin(0);
	scene.inGameMenuToggle.x -= scene.inGameMenuToggle.width;
	scene.uiGroup.add(scene.inGameMenuToggle);
	scene.inGameMenuToggle.on('pointerdown', function () {

		setTimeout(function()
		{
			scene.uiActive = false;
			scene.input.manager.activePointer.isDown = false;
		}, 250);

		// scene.returnToLobby(scene);
		let inGameMenuModalButton = document.getElementById('login');
		inGameMenuModalButton.dataset.target = '#inGameMenuModal';
		inGameMenuModalButton.click();
		userAccounts.getUserData(scene).then(function(userData) {
			// Update HTML elements.
			document.getElementById('inGameMenuModalBody').style.display = 'inline';
			document.getElementById('inGameMenuEmail').innerHTML = 'Email: ' + scene.userData.email;
			document.getElementById('inGameMenuHoney').innerHTML = 'Honey: <br> <img src="src/assets/individualImages/honeyIcon.png" alt="Honey">' + ' ' + scene.userData.honey;
			document.getElementById('inGameMenuWorkersCreated').innerHTML = 'Workers Created: <br> <img src="src/assets/individualImages/workerIcon.png" alt="Workers Created">' + ' ' + scene.userData.workersCreated;
		}).catch(function(error) {
			console.log('An error occured: %o', error);
			document.getElementById('inGameMenuModalBody').style.display = 'none';
		});

	});

	scene.minimapCamera = scene.cameras.add(scene.minimapX, scene.minimapY, scene.minimapWidth, scene.minimapHeight)
		.setZoom(0.125)
		.setSize(1,1)
		.setPosition(scene.minimapX, scene.minimapY)
		.setBackgroundColor('rgba(191,175,153,0.5)');

	// Create the swarm button
	scene.swarmButton = scene.add.sprite(25, window.innerHeight - 25, 'sprites', 'swarm.png')
		.setScrollFactor(0)
		.setInteractive()
		.setOrigin(0);
	scene.uiGroup.add(scene.swarmButton);
	scene.actionButtons.add(scene.swarmButton);
	scene.swarmButton.y -= scene.swarmButton.height;
	scene.swarmButton.on('pointerdown', function () {
		swarmButtonToggle(scene);
	});

	// Create the new hive button
	scene.newHiveButton = scene.add.sprite(25, window.innerHeight - 25, 'sprites', 'newHive.png')
		.setScrollFactor(0)
		.setInteractive()
		.setOrigin(0);
	scene.uiGroup.add(scene.newHiveButton);
	scene.actionButtons.add(scene.newHiveButton);
	scene.newHiveButton.x += scene.newHiveButton.width + 25;
	scene.newHiveButton.y -= scene.newHiveButton.height;
	scene.newHiveButton.ready = true;
	scene.newHiveButton.on('pointerdown', function ()
	{
		newHiveButtonToggle(scene);
	});

	// Create the lay egg button.
	scene.layEggButton = scene.add.sprite(25, window.innerHeight - 25, 'sprites', 'layEgg.png')
		.setScrollFactor(0)
		.setInteractive()
		.setOrigin(0);
	scene.layEggButton.x += (scene.layEggButton.width * 2) + 50;
	scene.layEggButton.y -= scene.layEggButton.height;
	scene.layEggButton.scaleX = 0;
	scene.layEggButton.scaleY = 0;
	scene.layEggButton.isShrinking = false;
	scene.layEggButton.isShrunk = true;
	scene.layEggButton.isExpanding = false;
	scene.layEggButton.isExpanded = false;
	scene.layEggButton.ready = true;
	scene.uiGroup.add(scene.layEggButton);
	scene.actionButtons.add(scene.layEggButton);
	scene.uiGroup.setDepth(1000);
	scene.layEggButton.on('pointerdown', function () {
		layEggButtonToggle(scene);
	});

	// Create the attack button
	scene.attackButton = scene.add.sprite(25, window.innerHeight - 25, 'sprites', 'attack.png')
		.setScrollFactor(0)
		.setInteractive()
		.setOrigin(0);
	scene.uiGroup.add(scene.attackButton);
	scene.actionButtons.add(scene.attackButton);
	scene.attackButton.x += (scene.attackButton.width * 3) + 75;
	scene.attackButton.y -= scene.attackButton.height;
	scene.attackButton.ready = true;
	scene.attackButton.on('pointerdown', function ()
	{
		attackButtonToggle(scene);
	});

	// Create the eat honey button.
	scene.eatHoneyButton = scene.add.sprite(25, window.innerHeight - 25, 'sprites', 'eatHoney.png')
		.setScrollFactor(0)
		.setInteractive()
		.setOrigin(0);
	scene.eatHoneyButton.x += (scene.eatHoneyButton.width * 4) + 100;
	scene.eatHoneyButton.y -= scene.eatHoneyButton.height;
	scene.eatHoneyButton.scaleX = 0;
	scene.eatHoneyButton.scaleY = 0;
	// this.expandButton(scene.eatHoneyButton);
	scene.eatHoneyButton.isShrinking = false;
	scene.eatHoneyButton.isShrunk = true;
	scene.eatHoneyButton.isExpanding = false;
	scene.eatHoneyButton.isExpanded = false;
	scene.eatHoneyButton.ready = true;
	scene.uiGroup.add(scene.eatHoneyButton);
	scene.actionButtons.add(scene.eatHoneyButton);
	scene.uiGroup.setDepth(1000);
	scene.eatHoneyButton.on('pointerdown', function () {
		eatHoneyButtonToggle(scene);
	});

	if (window.innerWidth < 440)
	{
		adjustButtonsForMobile(scene);
	}

	scene.minimapCamera.ignore(scene.uiGroup);


	// messageBoxes
	scene.messageBoxes.push( new classes.messageBoxes(scene) );

	disableMovementOverUI(scene);

	// Virtual Joystick
	if (scene.virtualJoystickEnabled == 'true')
	{
		createVirtualJoystick(scene);
	}

	if (window.innerWidth < this.mobileWidth)
	{
		adjustButtonsForMobile(scene);
	} else {
		adjustButtonsBackToFullSize(scene);
	}

}

export function createVirtualJoystick(scene)
{
	scene.virtualJoyStick = scene.plugins.get('rexvirtualjoystickplugin').add(scene, {
			  x: (window.innerWidth),
			  y: (window.innerHeight),
			  radius: 50,
			  base: scene.add.circle(0, 0, 50, 0xf0db87, .5),
			  thumb: scene.add.circle(0, 0, 20, 0x3c2040),
			  dir: '8dir',   // 'up&down'|0|'left&right'|1|'4dir'|2|'8dir'|3
			  // forceMin: 16,
			  enable: true
	  });
	  scene.virtualJoyStick.base.isStroked = true;
	  scene.virtualJoyStick.base.strokeColor = 0xf0db87;
	  scene.virtualJoyStick.base.lineWidth = 4;
	  // scene.virtualJoyStick.thumb.setAlpha(.85);
	  scene.virtualJoyStick.x -= scene.virtualJoyStick.radius + 25;
	  scene.virtualJoyStick.y -= scene.virtualJoyStick.radius + 25;
	  scene.virtualJoyStick.thumb.x = scene.virtualJoyStick.x;
	  scene.virtualJoyStick.thumb.y = scene.virtualJoyStick.y;

	  scene.virtualJoyStick.cursorKeys = scene.virtualJoyStick.createCursorKeys();
	  scene.virtualJoyStick.leftKeyDown = scene.virtualJoyStick.cursorKeys.left.isDown;
	  scene.virtualJoyStick.rightKeyDown = scene.virtualJoyStick.cursorKeys.right.isDown;
	  scene.virtualJoyStick.upKeyDown = scene.virtualJoyStick.cursorKeys.up.isDown;
	  scene.virtualJoyStick.downKeyDown = scene.virtualJoyStick.cursorKeys.down.isDown;

	  scene.uiGroup.add(scene.virtualJoyStick.base);
	  scene.uiGroup.add(scene.virtualJoyStick.thumb);

	  if (window.innerWidth < scene.mobileWidth + 50)
	  {
		  // Move the joystick up to avoid the action buttons.
		  scene.virtualJoyStick.setPosition(
			  (window.innerWidth) - (scene.virtualJoyStick.radius + 25),
			  (window.innerHeight) - (scene.virtualJoyStick.radius + 125),
		  );
		  scene.virtualJoyStick.thumb.setPosition(
			  (window.innerWidth) - (scene.virtualJoyStick.radius + 25),
			  (window.innerHeight) - (scene.virtualJoyStick.radius + 125),
		  );
	  }

	  scene.minimapCamera.ignore(scene.uiGroup);
	  utility.setDepthOfGroups(scene);
}

export function disableMovementOverUI(scene)
{
	try {
		scene.uiActive = false;
		var uiElements = scene.uiGroup.getChildren();
		for (var i = 0; i < uiElements.length; i++)
		{
			uiElements[i].on('pointerdown', function (event) {
				this.scene.uiActive = true;
				// After some time, check that uiActive got disabled.
				let that = this;
				setTimeout(function()
				{
					if (that.scene.uiActive)
					{
						that.scene.uiActive = false;
					}
				}, 250);
			});

			uiElements[i].on('pointerup', function (event) {
				this.scene.uiActive = false;
			});
		}
	} catch(e) {
		console.log('There was an error disabling movement over UI: ', e);
	}
}

export function swarmButtonToggle(scene)
{
	scene.queenBees[0].followPheromoneActive = !scene.queenBees[0].followPheromoneActive;
	if (scene.queenBees[0].followPheromoneActive == true)
	{
		scene.swarmButton.setTint(0xafd5aa);
	} else
	{
		scene.swarmButton.setTint(16777215);
	}
}

export function newHiveButtonToggle(scene)
{
	if (scene.newHiveButton.ready == true)
	{
		scene.newHiveButton.ready = false;
		scene.newHiveButton.inCooldown = true;
		scene.newHiveButton.setTint(0xafd5aa);
		scene.hives.push( new classes.Hives(scene, scene.queenBees[0].queenBeeSprite.x, scene.queenBees[0].queenBeeSprite.y) );
		utility.setDepthOfGroups(scene);

		// Create progress bar
		var rect = new Phaser.Geom.Rectangle(scene.newHiveButton.x, scene.newHiveButton.y - 15, scene.newHiveButton.width, 15);
		var progressBar = scene.add.graphics({ fillStyle: { color: 0x7698b3 } });
		progressBar.setScrollFactor(0);
		progressBar.fillRectShape(rect);
		progressBar.setScale(0,1);
		var progressBarTween = scene.tweens.add({
			targets: progressBar,
			scaleX: '1',
			duration: 20000,
			ease: 'Linear',
			onComplete: newHiveProgressBarDone
		});
	}
}

export function layEggButtonToggle(scene)
{
	try {
		if (scene.selectedEggLayCell &&
			scene.selectedEggLayCell.typeOfCell == 'empty' &&
			scene.layEggButton.ready == true)
		{
			scene.queenBees[0].setLayEggAnimation(scene.queenBees[0].queenBeeSprite, scene.selectedEggLayCell);
			scene.layEggButton.ready = false;
			scene.layEggButton.setTint(0xafd5aa);
			scene.selectedEggLayCell.typeOfCell  = 'brood';
			scene.broods.push( new classes.Broods(scene, scene.selectedEggLayCell.x, scene.selectedEggLayCell.y, 'egg.png', scene.username, scene.selectedEggLayCell) );
			utility.setDepthOfGroups(scene);

			// Create progress bar
			var rect = new Phaser.Geom.Rectangle(scene.layEggButton.x, scene.layEggButton.y - 15, scene.layEggButton.width, 15);
			var progressBar = scene.add.graphics({ fillStyle: { color: 0x7698b3 } });
			progressBar.setScrollFactor(0);
			progressBar.fillRectShape(rect);
			progressBar.setScale(0,1);
			var progressBarTween = scene.tweens.add({
				targets: progressBar,
				scaleX: '1',
				duration: 1000,
				ease: 'Linear',
				onComplete: eggLayProgressBarDone
			});
		}
	} catch(e) {
		console.log('There was an error when lay egg button was toggled: ', e);
	}
}

export function attackButtonToggle(scene)
{
	try {

		scene.queenBees[0].alarmPheromoneActive = !scene.queenBees[0].alarmPheromoneActive;
		if (scene.queenBees[0].alarmPheromoneActive == true)
		{
			scene.attackButton.setTint(0xafd5aa);
			scene.queenBees[0].alarmPheromoneParticles.emitting = true;
			
			scene.workers.forEach(function(worker)
			{
				if (worker.username == worker.scene.username)
				{
					worker.alarmPheromoneParticles.emitting = true;
				}
			});

		} else
		{
			scene.attackButton.setTint(16777215);
			scene.queenBees[0].alarmPheromoneParticles.emitting = false;

			scene.workers.forEach(function(worker)
			{
				if (worker.username == worker.scene.username)
				{
					worker.alarmPheromoneParticles.emitting = false;
				}
			});
		}
	} catch(e) {
		console.log("There was an error toggling attack: ", e);
	}


}

export function eatHoneyButtonToggle(scene)
{
	if (scene.eatHoneyButton.ready == true)
	{

		let closestHoney = utility.closestHoney(scene, scene.queenBees[0].queenBeeSprite);
		if (closestHoney)
		{
			var distanceBetweenHoneyAndQueen = Phaser.Math.Distance.Between(
				closestHoney.x,
				closestHoney.y,
				scene.queenBees[0].queenBeeSprite.x,
				scene.queenBees[0].queenBeeSprite.y);
			if (distanceBetweenHoneyAndQueen <= 250)
			{
				scene.eatHoneyButton.ready = false;
				scene.eatHoneyButton.setTint(0xafd5aa);

				if (closestHoney.cell)
				{
					closestHoney.cell.typeOfCell = 'empty';
				}
				closestHoney.destroy();

				scene.queenBees[0].healthChange(scene.queenBees[0], 'heal', 10);

				utility.emitPlusOneHoneyEmitter(scene);
				createEatHoneyButtonProgressBar(scene);
				if (scene.userData)
				{
					userAccounts.addHoneyToUserAccount(scene, 1).then(function(res) {
						console.log('Response from adding honey is: ', res)
					});
				}
			}
		}
	}
}

export function createEatHoneyButtonProgressBar(scene)
{
	// Create progress bar
	var rect = new Phaser.Geom.Rectangle(scene.layEggButton.x, scene.layEggButton.y - 15, scene.layEggButton.width, 15);
	var progressBar = scene.add.graphics({ fillStyle: { color: 0x7698b3 } });
	progressBar.setScrollFactor(0);
	progressBar.fillRectShape(rect);
	progressBar.setScale(0,1);
	var progressBarTween = scene.tweens.add({
		targets: progressBar,
		scaleX: '1',
		duration: 1000,
		ease: 'Linear',
		onComplete: eatHoneyProgressBarDone
	});
}

export function resizeScene(gameSize, baseSize, displaySize, resolution)
{
	try {
		// Save minimap camera size.
		let minimapWidth = this.minimapCamera.width;
		let minimapHeight = this.minimapCamera.height;

		var width = window.innerWidth;
		var height = window.innerHeight;
		this.cameras.resize(width, height);

		this.minimapCamera.setSize(minimapWidth, minimapHeight);

		// Set new button coordinates.
		sceneData.swarmButton.setY(window.innerHeight - 25 - sceneData.swarmButton.height);
		sceneData.newHiveButton.setY(window.innerHeight - 25 - sceneData.newHiveButton.height);
		if (this.layEggButton)
		{
			sceneData.layEggButton.setY(window.innerHeight - 25 - sceneData.layEggButton.height);
		}
		sceneData.attackButton.setY(window.innerHeight - 25 - sceneData.attackButton.height);
		sceneData.eatHoneyButton.setY(window.innerHeight - 25 - sceneData.eatHoneyButton.height);

		sceneData.inGameMenuToggle.setX(window.innerWidth - sceneData.inGameMenuToggle.width - 25);

		if (this.virtualJoystickEnabled == 'true')
		{
			if (window.innerWidth < this.mobileWidth + 50)
			{
				// Move the joystick up to avoid the action buttons.
				this.virtualJoyStick.setPosition(
					(window.innerWidth) - (sceneData.virtualJoyStick.radius + 25),
					(window.innerHeight) - (sceneData.virtualJoyStick.radius + 125),
				);
			} else {
				sceneData.virtualJoyStick.setPosition(
					(window.innerWidth) - (sceneData.virtualJoyStick.radius + 25),
					(window.innerHeight) - (sceneData.virtualJoyStick.radius + 25),
				);
			}

			sceneData.virtualJoyStick.thumb.x = sceneData.virtualJoyStick.x;
			sceneData.virtualJoyStick.thumb.y = sceneData.virtualJoyStick.y;
			// console.log('joystick rezize', this.virtualJoyStick);
		}

		// Leaderboard position
		sceneData.workerCountSprites.forEach(function(workerCountSprite, i)
		{
			if (workerCountSprite)
			{
				let scene = workerCountSprite.scene;
				scene.workerCountSprites[i].setX(window.innerWidth - scene.workerCountSprites[i].width - 25);
				scene.scoreTexts[i].setX(scene.workerCountSprites[i].x + (scene.workerCountSprites[i].width/2));
				scene.scoreUsernameTexts[i].setX(scene.scoreTexts[i].x - 50);
			}
		});
		if (this.localWorkerCountSprite)
		{
			this.localWorkerCountSprite.setX(window.innerWidth - this.localWorkerCountSprite.width - 25);
			this.localScoreText.setX(this.localWorkerCountSprite.x + (this.localWorkerCountSprite.width/2));
			this.localScoreUsernameText.setX(this.localScoreText.x - 50);
		}
		if (this.yellowJacketCountSprite)
		{
			this.yellowJacketCountSprite.setX(window.innerWidth - this.yellowJacketCountSprite.width - 25);
			this.yellowJacketScoreText.setX(this.yellowJacketCountSprite.x + (this.yellowJacketCountSprite.width/2));
		}

		if (this.queenBeeCountSprite)
        {
			this.queenBeeCountSprite.setX(window.innerWidth - this.queenBeeCountSprite.width - 25);
			this.queenBeeScoreText.setX(this.queenBeeCountSprite.x + (this.queenBeeCountSprite.width/2));
		}

		if (this.giantWaspCountSprite)
        {
			this.giantWaspCountSprite.setX(window.innerWidth - this.giantWaspCountSprite.width - 25);
			this.giantWaspScoreText.setX(this.giantWaspCountSprite.x + (this.giantWaspCountSprite.width/2));
		}


		this.messageBoxes[0].moveMessageBox(this);

		if (window.innerWidth < this.mobileWidth)
		{
			adjustButtonsForMobile(sceneData);
		} else {
			adjustButtonsBackToFullSize(sceneData);
		}
	} catch(err) {
		console.log('Error while resizing screen.', err);
	}

}

export function adjustButtonsForMobile(scene)
{
	try
	{
		var actionButtons = scene.actionButtons.getChildren();
		for (var i = 0; i < actionButtons.length; i++)
		{
			actionButtons[i].setScale(scene.mobileActionButtonScale);
		}

		if (scene.buttonsScaledDown == false)
		{
			scene.newHiveButton.x -= 35;
			scene.layEggButton.x -= 73;
			scene.attackButton.x -= 110;
			scene.eatHoneyButton.x -= 140;
		}

		scene.buttonsScaledDown = true;
	} catch(err) {
		console.log('Error while adjusting buttons on mobile.', err);
	}
}

export function adjustButtonsBackToFullSize(scene)
{
	try
	{
		let fullSize = 1;

		var actionButtons = scene.actionButtons.getChildren();
		for (var i = 0; i < actionButtons.length; i++)
		{
			actionButtons[i].setScale(fullSize);
		}

		if (scene.buttonsScaledDown == true)
		{
			scene.newHiveButton.x += 35;
			scene.layEggButton.x += 73;
			scene.attackButton.x += 110;
			scene.eatHoneyButton.x += 140;
		}

		scene.buttonsScaledDown = false;
	} catch(err) {
		console.log('Error while adjusting the size of buttons.', err);
	}

}

export function inGameMenuButtons(scene)
{
	try {
		var returnToLobbyButton;
		returnToLobbyButton = document.getElementById('returnToLobbyMenuButton');
		returnToLobbyButton.onclick = function() {
			console.log('Clicked Menu Button: Return to Lobby');
			let closeInGameMenuModalButton = document.getElementById('closeInGameMenuModal');
			closeInGameMenuModalButton.click();
			scene.returnToLobby(scene);
			let inGameMenuModalButton = document.getElementById('login');
			inGameMenuModalButton.dataset.target = '#loginModal';
		}

		var continuePlayingButton = document.getElementById('continuePlayingButton');
		continuePlayingButton.onclick = function() {
			console.log('Clicked continue playing button.');
			$('#winLossModal').modal('hide');
		}
		var nextLevelButton = document.getElementById('nextLevelButton');
		nextLevelButton.onclick = function() {
			console.log('Clicked next level button.');
			$('#winLossModal').modal('hide');
			if (!scene.challengeFail)
			{
				scene.returnToLobby(scene);
				$('#challengeSelectModal').modal('show');
			} else {
				scene.restartScene(scene);
			}

		}
	} catch(err) {
		console.log('Error while creating in-game menu buttons.', err);
	}
}

export function eggLayProgressBarDone(tween, target) {
	target[0].scene.layEggButton.ready = true;

	tween.parent.scene.layEggButton.setTint(16777215);

	target[0].destroy();
}

export function eatHoneyProgressBarDone(tween, target) {
	// console.log('Progress bar finished', tween, target);
	target[0].scene.eatHoneyButton.ready = true;

	tween.parent.scene.eatHoneyButton.setTint(16777215);

	target[0].destroy();
}

export function shrinkButton (button)
{
	button.isExpanded = false;
	button.isShrinking = true;

	button.scene.tweens.add({
		targets: button,
		scaleX: '0',
		scaleY: '0',
		alpha: '0',
		duration: 500,
		ease: 'Sine',
		onComplete: buttonDoneShrinking(button)
	});
}

export function buttonDoneShrinking(button)
{
	button.isShrinking = false;
	button.isShrunk = true;
}

export function expandButton (button)
{
	button.isShrunk = false;
	button.isExpanding = true;

	if (button.scene.buttonsScaledDown)
	{
	   var scale = button.scene.mobileActionButtonScale;
	} else
	{
		var scale = 1;
	}

	button.scene.tweens.add({
		targets: button,
		scaleX: scale,
		scaleY: scale,
		alpha: 1,
		duration: 500,
		ease: 'Sine',
		onComplete: buttonDoneExpanding(button)
	});
}

export function buttonDoneExpanding(button)
{
	button.isExpanding = false;
	button.isExpanded = true;
}

export function newHiveProgressBarDone(tween, target) {
	// console.log('Progress bar finished', tween, target);
	target[0].scene.newHiveButton.ready = true;
	target[0].scene.newHiveButton.inCooldown = false;
	// target[0].scene.queenBees[0].newHiveSprite.alpha = .5;
	tween.parent.scene.newHiveButton.setTint(16777215);
	target[0].destroy();
}

export function disableUI(scene)
{
	scene.minimapToggle.setInteractive(false);
	scene.swarmButton.setInteractive(false);
	scene.newHiveButton.setInteractive(false);
	scene.attackButton.setInteractive(false);

	scene.minimapToggle.setAlpha(0);
	scene.swarmButton.setAlpha(0);
	scene.newHiveButton.setAlpha(0);
	scene.attackButton.setAlpha(0);
}



// WEBPACK FOOTER //
// ./src/modules/ui.js